import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommunicationPreferencesService } from '../services/communication-preferences.service';
import {
  FormControl,
  ReactiveFormsModule,
  Validators,
  ɵInternalFormsSharedModule,
} from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { USER_PROFILE_NOTIFICATIONS_COLUMNS } from '@app/utils/constants/notification-choice-column.constants';
import { NotificationChoiceColumn } from '@app/utils/interfaces/notification-choice-column.interface';
import { CommunicationPreferenceTableData } from '@app/utils/types/communication-preferences.type';

@Component({
  selector: 'app-user-profile-notifications',
  standalone: true,
  imports: [
    TranslateModule,
    MatTableModule,
    ɵInternalFormsSharedModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
  ],
  templateUrl: './user-profile-notifications.component.html',
  styleUrl: './user-profile-notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileNotificationsComponent implements OnInit {
  protected readonly dataSource = new MatTableDataSource();
  protected readonly columns = USER_PROFILE_NOTIFICATIONS_COLUMNS;
  protected readonly displayedColumns = this.columns.map(
    (column: NotificationChoiceColumn) => column.id,
  );
  protected readonly emailControl = new FormControl('', [Validators.email]);
  private readonly communicationPreferenceService = inject(CommunicationPreferencesService);
  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.communicationPreferenceService
      .getPreferencesTableData()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((preferences: CommunicationPreferenceTableData[]) => {
        this.dataSource.data = preferences;
      });
  }

  public subscribe(): void {
    // TODO: Implement me when US 2.5's turn comes in!
  }

  private updatePreferences(): void {
    // TODO: Implement me when US 2.5's turn comes in!
  }
}
